
import { getAccretionService } from "@/api/oms-operation-service";
import { objAny } from "@/common/common-interface";
import { Component, Vue } from "vue-property-decorator";
import addServiceBox from "./components/add-service.vue";
@Component({
  components: {
    "add-service-box": addServiceBox
  }
})
export default class PiAddValueService extends Vue {
  private serviceList: object[] = [];
  private addServiceBox: objAny = {};
  private formInline: objAny = {};

  public updataClick(item: objAny) {
    this.addServiceBox.open(item);
  }
  public addClick() {
    this.addServiceBox.open();
  }
  async getTableList(): Promise<void> {
    const ret = await getAccretionService(this.formInline);
    if (ret.status === this["$config"].apiStatus) {
      this.serviceList = ret.data;
    }
  }

  mounted() {
    this.getTableList();
    this.$nextTick(() => {
      this.addServiceBox = this.$refs["addServiceBox"];
    });
  }
}
